import _, { isArray } from "lodash";
export const API_DATE_FORMAT = "YYYY-MM-DD";
export const reCAPTCHA_site_key = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const reCAPTCHA_secret_key = process.env.REACT_APP_RECAPTCHA_SECRET_KEY
// export const API_DATE_FORMAT = "YYYY-MM-DD hh:mm:ss";
/*export const DESC = "desc";
export const ASC = "asc";

export const SORT_ORDER_DESCEND = "descend";
export const SORT_ORDER_ASCEND = "ascend";
*/
export const WIZARD = {
  CARRIER: {
    "COUNTRY_FINANCIAL": "Country Financial"
  }
};
export const INTERNAL = "Internal";
export const EXTERNAL = "External";
export const CALL_TODAY_IS_SET_TO_YES = "Call Today is set to YES!";
export const SWITCH_BACK_TO_ADMIN = "Admin";
export const SWITCH_BACK_TO_ADMIN_POP_OVER = 'Switch back to the Admin workspace directly by hitting this button.'
export const CALL_TODAY_IS_SET_TO_NO = "Call Today is set to NO!";
export const REQUEST_CALL_POP_OVER = "Send a quick call request and have our scheduling team reach out to book a call."
export const LAUNCH_CALCULATOR_POP_OVER = "Open the calculator to quickly estimate values and plan your next steps."
export const COPY_RAC_POP_OVER = "Copy this Intelligence Link and share it with the customer to help them assess their liability limits."
export const TEMPLATE_BODY_COPIED = "Email template body copied successfully.";
export const TEMPLATE_SUBJECT_COPIED = "Email template subject copied successfully.";
export const IN = "IN";
export const TEST_AGENCY = "Test Agency";
export const TA = "TA"
export const INACTIVE_AGENCY = "Inactive Agency"
export const TOTAL_ASSETS_UNCOVERED = 'Total Assets Uncovered';
export const RETIREMENT_ASSETS_UNCOVERED = 'Retirement Assets Uncovered';
export const UMBRELLA_RECOMMENDED = 'Umbrellas Recommended';
export const TOTAL_P_AND_C_ITEMS = 'Total P&C Items';
export const LIFE_OPPORTUNITIES = 'Life Opportunities';
export const EXTERNAL_RAC_COMPLETED_BY_CLIENT = "External Intelligence Link Completed by Client";
export const EXTERNAL_RAC_COMPLETED_BY_CLIENT_FOR_INACTIVE_AGENCIES = "External Intelligence Link Completed by Client for Inactive Agencies";
export const INTERNAL_RAC_COMPLETED_BY_AGENCY = "Internal Intelligence Link Completed by Agency";
export const INTELLIGENCE_LINK_COMPLETED = "Intelligence Link Completed";
export const EXTERNALLY_COMPLETED_BFILE = "Externally Completed B Files";
export const SELECT_TIMEZONE = "Select Timezone";
export const TEMPORARY_LOCKED = "Temporary";
export const PERMANENT_LOCKED = "Permanent";
export const TYPE_TO_FILTER_BY_FIRST_NAME = "Type to filter by first name...";
export const TYPE_TO_FILTER_BY_LAST_NAME = "Type to filter by last name...";
export const TYPE_TO_FILTER_BY_EMAIL = "Type to filter by email...";
export const TYPE_TO_FILTER_BY_NAME = "Type to filter by name...";
export const TYPE_TO_FILTER_BY_SUB_TYPE = "Type to filter by sub type...";
export const TYPE_TO_FILTER_BY_SUB_TYPE_OR_CALL_ATTEMPTS = "Type to filter by sub-type...";
export const TYPE_TO_FILTER_BY_AGES = "Type to filter by ages...";
export const TYPE_TO_FILTER_BY_RETIREMENT = "Type to filter by retirement $...";
export const TYPE_TO_FILTER_BY_PNC_ITEMS = "Type to filter by pnc items...";
export const TYPE_TO_FILTER_BY_ATTEMPTS = "Type to filter by attempts...";
export const TYPE_TO_FILTER_BY_WHO_CREATED = "Type to filter by who created...";
export const TYPE_TO_FILTER_BY_APPOINTMENT_TIME = "Type to filter by time...";
export const TYPE_TO_FILTER_BY_SCHEDULE_WITH = "Type to filter by schedule with...";
export const TYPE_TO_FILTER_BY_PHONE = "Type to filter by phone...";
export const FAILED_TO_UPDATE_BAD_PHONE_NUMBER_STATUS = "Failed to update bad phone number status";
export const PLEASE_FILL_BOTH_LINK_TITLE_AND_URL_IN_ROW = "Please fill both Link Title and Link URL in row"

export const APPOINTMENT_REMINDER = "Appointment Reminder";
export const NO_USERS_TO_NOTIFY = "No Users to Notify";
export const REVIEW_SCHEDULER_APPOINTMENT = "Review Scheduler Appointment";
export const COUNTRY_FINANCIAL = "Country Financial";
export const INTERNAL_SYSTEM = "Internal System";
export const CANT_MAKE_APPOINTMENT = "Can't make appointment."
export const APPOINTMENT_SCHEDULED_SUCCESSFULLY = "Appointment scheduled successfully";
export const AGENT = "Agent";
export const TYPE = "Type";
export const ADMIN_DOWNLOAD_LAST_LOGIN = "/api/admin/download/last_login"
export const SOMETHING_WENT_WRONG = "Something went wrong.";
export const SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN = "Something went wrong. Please try again.";
export const FAILED_TO_REMOVE_PROFILE_PHOTO = 'Failed to remove profile photo.';
export const PROFILE_PHOTO = "Profile photo";
export const AGENCY_LOGO = 'Agency logo';
export const REMOVED_SUCCESSFULLY = 'removed successfully!';
export const AGENCY_LOGO_REMOVED_SUCCESSFULLY = 'Agency logo removed successfully!';
export const PROFILE_PHOTO_REMOVED_SUCCESSFULLY = 'Profile photo removed successfully!';
export const ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_IMAGE = 'Are you sure you want to remove this image?';
export const REVIEW_ACTIVE_MONTH_UPDATED_SUCCESSFULLY = "Review active month updated successfully.";
export const FOLLOW_UP_ACTIVE_MONTH_UPDATED_SUCCESSFULLY = "Follow-up active month updated successfully.";
export const EDIT_EA = 'Edit Agency Owner';
export const AGENCY_OWNER = "Agency Owner";
export const AGENCY_STAFF = "Agency Staff";
export const NOTE_PREFIX = "Submitted through the intelligence link by customer: ";
export const THANKYOU_REFERRALS = "Thank You / Referrals";
export const RE_QUOTE = "Re-Quote";
export const SEND_BFILE = "Send B File";
export const FOLLOW_UP_CALL = 'FollowUp';
export const PHONE_NUMBER_INVALID = 'Phone number is invalid.';
export const EMAIL_ADDRESS_IS_INVALID = 'Email address is invalid.';
export const EMAIL_IS_REQUIRED = 'Email is required.'
export const YES = 'Yes';
export const NO = 'No';
export const PLEASE_TRY_AGAIN_LATER = "Please try again later.";
export const INVALID_REQUEST_PLEASE_CHECK_YOUR_INPUT = "Invalid request. Please check your inputs."
export const NO_DATA_FOUND = "No data found";
export const DISCARD_BFILE_CONFIRMATION = "Do you want to discard this B File?";
export const MANDATORY_FIELDS_ERROR = "Please fill all the mandatory fields or your B File won't be saved!";
export const DISCARD_UPDATION_CONFIRMATION = 'Do you want to discard your changes?';
export const MANDATORY_FIELDS_ERROR_UPDATION = "Please fill all the mandatory fields or your changes won't be saved!";
export const PLEASE_ENTER_A_VALID_EMAIL_ADDRESS = "Please enter a valid email address."
export const PLEASE_SELECT_AT_LEAST_ONE_CARRIER = "Please select at least one carrier."
export const PLEASE_FILL_ALL_REQUIRED_FIELD = 'Please fill all required fields.';
export const PLEASE_FILL_TEMPLATE_TITLE = "Please fill the Template Title.";
export const PLEASE_FILL_TEMPLATE_SUBJECT = "Please fill the Template Subject.";
export const PLEASE_FILL_TEMPLATE_BODY = "Please fill the Template Body.";


export const NEW_BFILE = "New B File";
export const DESC = "desc";
export const ASC = "asc";
export const REACT_APP_GOOGLE_RECAPTCHA_ENABLE = false;
export const OWNERSHIP_TRANSFER_SUCCESS = "Ownership has been transferred successfully.";
export const OWNERSHIP_TRANSFER_FAILED = "Can't transfer Ownership.";



export const SORT_ORDER_DESCEND = "ascend";
export const SORT_ORDER_ASCEND = "descend";

export const TYPE_OF_CALL_REVIEW = "Review";
export const TYPE_OF_CALL_PROSPECT = "Prospect";
export const TYPE_OF_CALL_FOLLOW_UP = "Follow Up";
export const PROFILE_SAVED_FOR_LATER = "Profile has been saved for later";
export const PROFILE_UPDATED_SUCCESSFULLY = "Profile updated successfully";
export const PROFILE_HAS_BEEN_UPDATED_AND_SAVED_FOR_LATER = "Profile has been updated & saved for later";
export const BFILE_HAS_BEEN_UPDATED = "B File has been updated";
export const RENEWAL = "Renewal";
export const USER_HAS_BEEN_ENABLED = 'User has been enabled.'
export const EA = "EA";
export const LSP = "LSP";
export const ALL_AGENCIES = "All Agencies";
export const VONBOARDER = "VONBOARDER";
export const BOBADMIN = "BOBADMIN";
export const NO_REVIEW = "No Review";
export const NO_FOLLOW_UP = "No Follow-Up";
export const REVIEWADMIN = "REVIEWADMIN";
export const REVIEWSCHEDULER = "REVIEWSCHEDULER";
export const FOLLOW_UP_SPECIALIST_APPOINTMENT = 'Follow-Up Specialist Appointment';
export const CALL_BACK_REQUESTED = 'Call Back Requested';
export const CALL_BACK_REQUESTED_FOR = 'Call Back Requested for';
export const BAD_PHONE_NUMBER_REPORTED = "Bad Phone Number Reported";
export const BFILE_WILL_NOT_REAPPEAR_FOR_REVIEW = "B File will not re-appear for review.";
export const CURRENT_YEAR_REVIEW_ACTIVE_MONTH_IS = "Current review active month is";
export const BFILE_RECYCLE_IS_SCEDULED_FOR = "B File recycle is scheduled for";
export const REVIEW_SCHEDULER = "Review Scheduler";
export const FOLLOW_UP_SPECIALIST_ADMIN = "Follow-Up Specialist Admin";
export const FOLLOW_UP_SPECIALIST = "Follow-Up Specialist";
export const REVIEW_ADMIN = "Review Admin";
export const SUPER_ADMIN = "SUPER_ADMIN";
export const SUPERADMIN = "Super Admin";
export const RS_ADMIN_PATH = "dashboard-rs-admin";
export const REPORT_EXPORTED_SUCCESSFULLY = "Report exported successfully"
export const SELECT_FOLLOW_UP_SPECIALIST = "Select Follow-Up Specialist";
export const SELECT_SCHEDULER = "Select Scheduler";
export const AGENCY_NAME_IS_REQUIRED = "Agency Name is required"
export const BFILE_COMPLETED_SUCCESSFULLY = "B File Completed Successfully";
export const SERVER_URL = "https://bfilesystem.com/";    // prod URL
// export const SERVER_URL = "https://bfiledev.netlink.com/";     // dev URL
// export const SERVER_URL = "https://beta.bfilesystem.com/";     // beta URL
//export const SERVER_URL="http://10.209.3.5:8000/";
//export const SERVER_URL = "http://127.0.0.1:8000/";  //local url
export const BOBREVIEWADMIN = "BOBREVIEWADMIN";
export const BOB_REVIEW_ADMIN = "Bob Review Admin";
export const VONSCHEDULER = "VONSCHEDULER";
export const RFS = "Review & Follow-Up Specialist";
export const AGENCY_MANAGER = 'AGENCY_MANAGER';
export const AGENCYMANAGER = 'Agency Manager';
export const START_DATE = "2010-01-01";
export const END_DATE = "2050-01-01";
export const COMPLETED_HISTORY = 'Completed History';
export const BAD_PHONE_NUMBER = 'Bad Phone Number';
export const NOTIFICATIONS = 'Notifications';
export const WEEKLY_APPOINTMENT_RECAP = 'Weekly Appointment Recap';
export const WEEKLY_SCORECARD = 'Weekly Scorecard';
export const EXTERNAL_RAC = 'External Intelligence Link';
export const EXPORT_EXCEL = 'Export Excel';
export const EXPORT_DATA = 'Export Data';

export const REVIEW = 'Review';
export const LEAD = 'Lead';
export const OPPORTUNITY = 'Opportunity';
export const PROSPECT = 'Prospect';
export const FOLLOWUP = 'FollowUp';
export const DATE_FORMAT = "MM-DD-YYYY";
export const ALL = "all"
export const NO_ASSOCIATED_AGENCY = "No associated agency was found to transfer ownership.";
export const SELECT_USER = "Select User";
export const SELECT_REVIEW_SCHEDULER = "Select Review Scheduler";
export const SELECT_AGENCY_TO_TRANSFER = "Select Agency to Transfer";
export const UNASSIGN_TRANSFER_REQUIRED =
  "To unassign, please transfer ownership for this agency to some other scheduler.";

export const PHONE_NUMBER_COPIED_TO_CLIPBOARD = 'Phone number copied to clipboard';

// for Scheduling links constants type of call
export const TYPE_OF_SCHEDULING_CALL = {
  REVIEW: 'review',
  FOLLOWUP: 'folloup',
  PROSPECT: 'prospect'
}

//for cards history
export const CARD_HISTORY_TYPE = {
  UPLOAD: "upload",
  NON_RESPONSIVE: "not-responsive",
  NOT_INTERESTED: "not-interested",
  SCHEDULE_ACTIVITY: "scheduling-activity",
  ACTIVE_CALL: "active-call",
  COMPLETED: "completed",
  EXTERNALLY_COMPLETED_BFILE: "externally-completed-bfiles",
  INTELLIGENCE_LINK_COMPLETED: "intelligence-link-completed"
}

export const LEAD_DETAILS_SETTINGS = "Lead Details Settings"
export const UPDATE_PROFILE = 'Update Profile';

export const UTC = "UTC";

export const tzMap = {
  // US/Eastern
  "US/Eastern": "US/Eastern",
  "Eastern Standard Time": "US/Eastern",
  "America/New_York": "US/Eastern",
  "America/Detroit": "US/Eastern",

  // US/Central
  "US/Central": "US/Central",
  "Central Standard Time": "US/Central",
  "America/Chicago": "US/Central",
  "America/Mexico_City": "US/Central",

  // US/Mountain
  "US/Mountain": "US/Mountain",
  "Mountain Standard Time": "US/Mountain",
  "America/Denver": "US/Mountain",
  "America/Phoenix": "US/Mountain",

  // US/Pacific
  "US/Pacific": "US/Pacific",
  "Pacific Standard Time": "US/Pacific",
  "America/Los_Angeles": "US/Pacific",

  // US/Alaska
  "US/Alaska": "US/Alaska",
  "America/Anchorage": "US/Alaska",

  // US/Hawaii
  "US/Hawaii": "US/Hawaii",
  "Pacific/Honolulu": "US/Hawaii",

  // US/Samoa
  "US/Samoa": "US/Samoa",
  "Pacific/Samoa": "US/Samoa",

  // fallback
  null: "",
  "": "",
  false: "",
};


export const shortTZMap = {
  "US/Samoa": "SST",
  'Pacific/Samoa': 'SST'
};



export const SUB_TYPE_OF_CALL = {
  Review: [
    { label: "P&C Review", value: 'P&C Review' },
    { label: "Life Insurance Review", value: 'Life Insurance' },
    { label: "Commercial/Farm", value: 'Commercial' },
    { label: "Retirement", value: "Retirement" }],
  Prospect: [
    { label: "New Quote/Re-Quote", value: "Re-Quote" },
    { label: "Win-Back", value: "Win Back" },
    { label: "Event Call", value: "Event Call" }],
  FollowUp: [
    { label: "Thank You & Referrals", value: "Thank You / Referrals", disable: true },
    { label: "Life Insurance", value: "Life Insurance" },
    { label: "P&C Cross-Sell", value: "Cross-Sell" },
    { label: "Commercial/Farm", value: 'Commercial' },
    { label: "Retirement", value: "Retirement" }
  ],
};

export const type_of_call_format = (value = "") => {
  return value && value.split("-").join("").toLowerCase() || ""
}


export const get_label_from_value = (sub_type_of_call = "", val = {}, type_of_call = "") => {
  //  let arr =  Object.values(SUB_TYPE_OF_CALL).flat();
  // let arr = SUB_TYPE_OF_CALL[type_of_call];

  let arr = []
  let temp = []

  Object.keys(SUB_TYPE_OF_CALL).forEach((e) => {
    if (e.toLowerCase().includes(type_of_call_format(type_of_call))) {
      arr.push(SUB_TYPE_OF_CALL[e])
    }
  })

  arr = arr.flat()

  if (arr) {
    if (sub_type_of_call && sub_type_of_call.trim()) {
      sub_type_of_call.trim().split(",").forEach(e => {

        arr.forEach(index => {

          if (sub_type_of_call.trim().includes(";")) {
            if (sub_type_of_call.includes(index.value) && !sub_type_of_call.includes(index.label)) {
              sub_type_of_call = sub_type_of_call.replace(index.value, index.label);
            }
            else if (sub_type_of_call.includes(index.label) && !sub_type_of_call.includes(index.value)) {
              sub_type_of_call = sub_type_of_call.replace(index.label, index.label);
            }
            else if (sub_type_of_call.includes(index.label) && sub_type_of_call.includes(index.value)) {
              sub_type_of_call = sub_type_of_call.replace(index.value, index.value);
            }
          } else {
            if ([index.value, index.label].includes(e)) {
              temp.push(index[val])
            }
          }


        })


      })
    }
  }
  return sub_type_of_call && sub_type_of_call.trim().includes(";") ? sub_type_of_call : temp.join(",");

}

export const CSV_FORM_FIELDS = {
  Review: {
    "P&C Review": [
      {
        key: "first_name",
        value: "First Name",
        required: true,
        template: "review-pnc-and-commercial.csv",
      },
      { key: "last_name", value: "Last Name", required: true },
      { key: "phone", value: "Home Phone", required: true },
      { key: "email", value: "Email", required: false },
      {
        key: "rs_effective_date",
        value: "Active Call Date",
        required: false,
      },
      { key: "notes", value: "Notes", required: false },
      {
        key: "farm_bureau_number",
        value: "Farm Bureau Number",
        required: false,
      },
      {
        key: "salesforce_business_name",
        value: "Salesforce Business Name",
        required: false,
      },
    ],
    "Life Insurance": [
      { key: "first_name", value: "First Name", required: true },
      { key: "last_name", value: "Last Name", required: true },
      { key: "phone", value: "Home Phone", required: true },
      { key: "email", value: "Email", required: false },
      { key: "notes", value: "Notes", required: false },
      {
        key: "farm_bureau_number",
        value: "Farm Bureau Number",
        required: false,
      },
      {
        key: "salesforce_business_name",
        value: "Salesforce Business Name",
        required: false,
      },
    ],
    Commercial: [
      { key: "first_name", value: "First Name", required: true },
      { key: "last_name", value: "Last Name", required: true },
      { key: "phone", value: "Home Phone", required: true },
      { key: "email", value: "Email", required: false },
      {
        key: "rs_effective_date",
        value: "Active Call Date",
        required: false,
      },
      { key: "notes", value: "Notes", required: false },
      {
        key: "farm_bureau_number",
        value: "Farm Bureau Number",
        required: false,
      },
      {
        key: "salesforce_business_name",
        value: "Salesforce Business Name",
        required: false,
      },
    ],
    Retirement: [
      { key: "first_name", value: "First Name", required: true },
      { key: "last_name", value: "Last Name", required: true },
      { key: "phone", value: "Home Phone", required: true },
      { key: "email", value: "Email", required: false },
      { key: "notes", value: "Notes", required: false },
      {
        key: "farm_bureau_number",
        value: "Farm Bureau Number",
        required: false,
      },
      {
        key: "salesforce_business_name",
        value: "Salesforce Business Name",
        required: false,
      },
    ],
  },
  Prospect: {
    "Re-Quote": [
      { key: "first_name", value: "First Name", required: true },
      { key: "last_name", value: "Last Name", required: true },
      { key: "phone", value: "Home Phone", required: true },
      { key: "email", value: "Email", required: false },
      { key: "notes", value: "Notes", required: false },
      {
        key: "p_n_c_item_to_quote",
        value: "P&C Item to Quote",
        required: false,
      },
      {
        key: "farm_bureau_number",
        value: "Farm Bureau Number",
        required: false,
      },
      {
        key: "salesforce_business_name",
        value: "Salesforce Business Name",
        required: false,
      },
    ],
    "Win Back": [
      { key: "first_name", value: "First Name", required: true },
      { key: "last_name", value: "Last Name", required: true },
      { key: "phone", value: "Home Phone", required: true },
      { key: "email", value: "Email", required: false },
      { key: "notes", value: "Notes", required: false },
      {
        key: "p_n_c_item_to_quote",
        value: "P&C Item to Quote",
        required: false,
      },
      {
        key: "farm_bureau_number",
        value: "Farm Bureau Number",
        required: false,
      },
      {
        key: "salesforce_business_name",
        value: "Salesforce Business Name",
        required: false,
      },
    ],
  },
  FollowUp: {
    "Thank You / Referrals": [
      { key: "first_name", value: "First Name", required: true },
      { key: "last_name", value: "Last Name", required: true },
      { key: "phone", value: "Home Phone", required: true },
      { key: "email", value: "Email", required: false },
      {
        key: "rs_effective_date",
        value: "Active Call Date",
        required: false,
      },
      { key: "notes", value: "Notes", required: false },
      {
        key: "farm_bureau_number",
        value: "Farm Bureau Number",
        required: false,
      },
      {
        key: "salesforce_business_name",
        value: "Salesforce Business Name",
        required: false,
      },
    ],
    "Life Insurance": [
      { key: "first_name", value: "First Name", required: true },
      { key: "last_name", value: "Last Name", required: true },
      { key: "phone", value: "Home Phone", required: true },
      { key: "email", value: "Email", required: false },
      {
        key: "rs_effective_date",
        value: "Active Call Date",
        required: false,
      },
      { key: "notes", value: "Notes", required: false },
      {
        key: "farm_bureau_number",
        value: "Farm Bureau Number",
        required: false,
      },
      {
        key: "salesforce_business_name",
        value: "Salesforce Business Name",
        required: false,
      },
    ],
    "Cross-Sell": [
      { key: "first_name", value: "First Name", required: true },
      { key: "last_name", value: "Last Name", required: true },
      { key: "phone", value: "Home Phone", required: true },
      { key: "email", value: "Email", required: false },
      {
        key: "rs_effective_date",
        value: "Active Call Date",
        required: false,
      },
      { key: "notes", value: "Notes", required: false },
      {
        key: "farm_bureau_number",
        value: "Farm Bureau Number",
        required: false,
      },
      {
        key: "salesforce_business_name",
        value: "Salesforce Business Name",
        required: false,
      },
    ],
    Retirement: [
      { key: "first_name", value: "First Name", required: true },
      { key: "last_name", value: "Last Name", required: true },
      { key: "phone", value: "Home Phone", required: true },
      { key: "email", value: "Email", required: false },
      {
        key: "rs_effective_date",
        value: "Active Call Date",
        required: false,
      },
      { key: "notes", value: "Notes", required: false },
      {
        key: "farm_bureau_number",
        value: "Farm Bureau Number",
        required: false,
      },
      {
        key: "salesforce_business_name",
        value: "Salesforce Business Name",
        required: false,
      },
    ],
  },
};

export const CSV_COLUMNS = [
  { key: "first_name", value: "First Name" },
  { key: "last_name", value: "Last Name" },
  { key: "email", value: "E-mail" },
  { key: "address", value: "Mailing Street1" },
  { key: "address_cont", value: "Mailing Street2" },
  { key: "city", value: "Mailing City" },
  { key: "state", value: "Mailing State" },
  { key: "zipcode", value: "Mailing Zip" },
  { key: "phone", value: "Home Phone" },
  { key: "phone2", value: "Cell Phone" },
  { key: "expiration_date", value: "Schedule by Date" },
  { key: "rs_policy_type", value: "Policy Type" },
  // {
  //   key: "Review Active Month",
  //   value: "Review Active Month",
  // },
  {
    key: "Review Active Month",
    value: "Review Active Month",
  },
  {
    key: "followup_month",
    value: "Follow-up Active Month"
  },
  // {
  //   key: "fs_effective_date",
  //   value: "Follow-up Active Call Date"
  // },
  // {
  //   key: "fs_expiration_date",
  //   value: "Follow-up Schedule-by Call Date"
  // },
  { key: "p_n_c_item_to_quote", value: "P&C Item to Quote" },
  { key: "notes", value: "Notes" },
  //
  { key: "farm_bureau_number", value: "Farm Bureau Number" },
  { key: "salesforce_business_name", value: "Salesforce Business Name" },
];

export const TEMPLATE = {
  Review: {
    "P&C Review": "review-pnc-and-commercial.csv",
    "Life Insurance": "review-retirement-and-life-insurance.csv",
    Commercial: "review-pnc-and-commercial.csv",
    Retirement: "review-retirement-and-life-insurance.csv",
  },
  Prospect: {
    "Re-Quote": "prospect.csv",
    "Win Back": "prospect.csv",
  },
  FollowUp: {
    "Thank You / Referrals": "follow-up.csv",
    "Life Insurance": "follow-up.csv",
    "Cross-Sell": "follow-up.csv",
    Retirement: "follow-up.csv",
  },
};

// export const PROFILE_PDF_HEADERS = {"STATUS",};
export const PROFILE_PDF_HEADERS = {
  Status: "STATUS",
  Life_Stage: "LIFE STAGE",
  Asset_Accounts: "ASSET ACCOUNTS / RETIREMENT OPPORTUNITIES",
  Bfile_Financial_Recommendations: "B File Financial Recommendations",
  Household_Total_Assets: "Household Total Assets",
  P_n_C_ITEMS_IN_THE_HOUSEHOLD: "P & C ITEMS IN THE HOUSEHOLD",
};
export const debounceQuery = _.debounce((callback) => callback(), 1500);

export const CarrierList = [
  // {
  //   id: "0",
  //   name: "Select Plan...",
  // },
  {
    id: "1",
    name: "Allstate",
  },
  {
    id: "2",
    name: "Farmers",
  },
  {
    id: "3",
    name: "Country Financial",
  },
  {
    id: "4",
    name: "Farm Bureau",
  },
  {
    id: "5",
    name: "Independent Agent",
  },
]


export const URLPaths = {
  BFILES: "bfilesNew"
}


export const USER_TYPE_DROPDOWN = [
  {
    label: "Review Scheduler(RS)", key: "RS", value: "REVIEWSCHEDULER",
  },
  {
    label: "Follow-up Specialist(FS)", key: "FS", value: "VONBOARDER",

  },
  {
    label: "Review Follow-Up Scheduler(RFS)", key: "RFS", value: "VONSCHEDULER",
  }
];


export const TYPE_OF_CALL = {
  Review: "Review",
  Prospect: "Lead",
  FollowUp: "Opportunity"
}

export const TYPE_OF_ROLES = (selectedRoles) => {
  const TYPE_OF_CALLS_BASED_ON_SELECTED_ROLES = {
    "Review": "Review",
    "Lead": "Prospect",
    "Opportunity": "FollowUp"
  }
  // selected roles array
  let selectedUserType = selectedRoles.map(item => TYPE_OF_CALLS_BASED_ON_SELECTED_ROLES[item]).join(",")

  return selectedUserType
}


export const getFullUserType = (user) => {
  let userTypeobj = {
    "RS": "REVIEWSCHEDULER",
    "FS": "VONBOARDER",
    "RFS": "VONSCHEDULER"
  }

  return userTypeobj[user]
}

export const rolesFilter = async (roles, selectedRoles) => {
  let or = [];

  selectedRoles.forEach((userType) => {
    or.push({
      and: [
        {
          name: "roles",
          op: "any",
          val: {
            name: "role_id",
            op: "==",
            // val: "3",
            val: roles.find(item => item.value === userType).role_id,
          },
        },
      ],
    });
  });

  return or;




}




export const getNameInitials = (fullName) => {


  // Check if fullName is a non-empty string
  if (fullName && typeof fullName === 'string' && fullName.trim() !== '') {
    const splitFullName = fullName.trim().split(' ').map((name) => name[0]);

    if (splitFullName.length > 0) {
      return `${splitFullName[0].toUpperCase()}${splitFullName.length > 1 ? splitFullName[splitFullName.length - 1].toUpperCase() : ""}`;
    }
  }

  return '';
};


export const removeHeaderTitle = () => {
  localStorage.removeItem("menuTitle")
}

const callMetrics = {
  // live grid labels
  "Upcoming Calls": "upcoming_calls",
  "Due Calls": "due_calls",
  "Non Responsive": "non_responsive",
  "Bad Phone Number": "bad_phone_number",

  // 
};

const historyMetrics = {
  "Call Attempts": "call_attempts",
  "Phone Appointments": "phone_appointments",
  "Office Appointments": "office_appointments",
  "Virtual Appointments": "virtual_appointments",
  "Reschedule Appointments": "reschedule_appointments",
  "Call Back Requested": "call_back_requested",
  "Life Insurance": "life_insurance",
  // "PNC Review": "pnc_review",
  "P&C": "pnc_review",
  "Commercial": "commercial",
  "Retirement": "retirement",
  "Not Interested": "not_interested",
  "Call Attempts": "call_attempts",
  "Appointment Scheduled": "appointment_scheduled"
}

export function getCallMetricValue(key) {
  return callMetrics[key] || null;
}




// WEBPACK FOOTER //
// ./src/utils/Constants.js